import { useMutation } from '@tanstack/react-query';
import type { RequestBody } from '../../../../../types/typeHelper';
import { useApiClient } from '../../client';

export function useRegisterPushMutation() {
  const client = useApiClient();

  return useMutation({
    mutationFn: async ({ body }: { body: RequestBody<'/chat/push-devices', 'post'> }) => {
      return client.POST('/chat/push-devices', {
        body,
      });
    },
  });
}
